import Container from '@mui/material/Container';
import React from 'react';
import OrganizationForm from '../components/organizations/OrganizationForm';

const Organization: React.FC = () => {
  return (
    <Container>
      <OrganizationForm />
    </Container>
  );
};

export default Organization;
